/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
// utils
import axios from 'axios';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useAuth } from '../../components/context/Info';
import FavoritosComponent from '../../components/fixed/favoritos/FavoritosComponent';
import WhatsAppComponent from '../../components/fixed/whatsapp/WhatsappComponent';
import WelcomePiecesCompany from '../../components/pieces/welcomeCompany/WelcomePiecesCompany';
import PopUpComponent from '../../components/popUp/PopUpComponent';
import RealEstateSchemaMarkup from '../../components/screma/RealEstateSchemaMarkup';
import { getImoveisListServerSideProps } from '../../lib/server/site-props';
import { propertiesFilter, propertiesFilterPromocao, propertiesMapa, propertiesMapaPromocao } from '../../services/properties';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados, getCompany } from '../../services/selectors';
import { apenasArray, formatCaracteristicas, formatSelects, formatSelectsEstados, formatSelectsTransacao, isColorLight, removerAcentos } from '../../utils/FunctionsGlobals';
import {
    getHomeScopedStorageKey,
    getImoveisListCategoryStorageKey,
    getImoveisListCaracteristicasStorageKey,
    getImoveisListDatasStorageKey,
    getImoveisListStatesStorageKey,
    readJsonStorageValue,
} from '../../utils/homeCache';
import { buildImoveisSeo } from '../../utils/imoveisSeo';
import ListPiecesProperties from './components/pieces/list/ListPiecesProperties';
const AboutPieces = dynamic(() => import('../../components/pieces/about/AboutPieces'), { ssr: false });
const AboutPieces1 = dynamic(() => import('../../components/pieces/about1/AboutPieces1'), { ssr: false });
const AboutPieces2 = dynamic(() => import('../../components/pieces/about1/AboutPieces2'), { ssr: false });
import { getWithTTL, setWithTTL } from '../../utils/storage';
import styles from './Properties.module.css';

export const getServerSideProps = getImoveisListServerSideProps;

const Properties = () => {
    // constants
    const {
        allDataHome,
        favorito,
        setFavorito,
        isMobile1,
        init_props,
        setAllCompany,
        allCompany,
        getOnlyQuery1,
        setGetOnlyQuery1,
        setListCategory,
        listCategory,
        listCaracteristicas,
        listDatas,
        listEstados,
        setListDatas,
        setListCaracteristicas,
        setListEstados,
        ultimaConsulta,
        allViewProperties,
        setUltimaConsulta
    } = useAuth();

    const router = useRouter();
    const { pagination } = router.query;
    const { favoritos } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const { utm_campaign } = router.query;
    const { promocao } = router.query;
    const { min } = router.query;
    const { area_min } = router.query;
    const { area_max } = router.query;
    const { max } = router.query;
    const { banheiros } = router.query;
    const { dormitorios } = router.query;
    const { id_caracteristica } = router.query;
    const { data_entrega } = router.query;
    const { suites } = router.query;
    const { vagas } = router.query;
    const { ordem } = router.query;
    const { codsite } = router.query;
    const { transacao } = router.query;
    const { agenciador } = router.query;
    const agenciadorRaw = Array.isArray(agenciador) ? agenciador[0] : agenciador;
    const agenciadorParsed = agenciadorRaw ? Number(agenciadorRaw) : 0;
    const agenciadorId = Number.isFinite(agenciadorParsed) ? agenciadorParsed : 0;
    const categoria: number = router.query.categoria ? +router.query.categoria : 0;
    const id_estado: number = router.query.id_estado ? +router.query.id_estado : 0;
    const initialAsPath = init_props?.asPath || '';
    const currentAsPath = router.asPath || initialAsPath;
    const codsite2 = init_props?.codsite;
    const routeSearchParams = new URLSearchParams(
        String(currentAsPath || '').split('?')[1] || ''
    );
    const getRouteQueryValue = (value: unknown, key: string) => {
        if (Array.isArray(value)) return value[0];
        if (value !== undefined && value !== null && value !== '') return String(value);
        const fromPath = routeSearchParams.get(key);
        return fromPath !== null ? fromPath : undefined;
    };
    const parsePositiveQueryNumber = (value: unknown) => {
        const rawValue = Array.isArray(value) ? value[0] : value;
        const parsed = Number(rawValue);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    };
    const normalizePath = (path: string) => removerAcentos(path || '').toLowerCase();
    const stripIgnoredQuery = (path: string, ignoreKeys: string[] = []) => {
        const [base, query = ''] = String(path || '').split('?');
        if (!query) return base;
        const params = new URLSearchParams(query);
        ignoreKeys.forEach((key) => params.delete(key));
        const rest = params.toString();
        return rest ? `${base}?${rest}` : base;
    };
    const normalizeForCompare = (path: string) =>
        normalizePath(stripIgnoredQuery(path, ['debugImoveis', 'filtros']));
    const getSearchSignature = (path: string) => normalizeForCompare(path);
    const getSearchCacheKey = (path: string) => `ultima_consulta:${getSearchSignature(path)}`;
    const getCachedSearch = (path: string) => getWithTTL<any>(getSearchCacheKey(path));
    const LIST_CACHE_TTL = 60 * 60 * 1000; // 1 hora
    const SEARCH_CACHE_EXPIRES_AT_FIELD = '__imoveisSearchCacheExpiresAt';
    const withSearchCacheTTL = (value: any) => {
        if (!value || typeof value !== 'object') return value;

        return {
            ...value,
            [SEARCH_CACHE_EXPIRES_AT_FIELD]: Date.now() + LIST_CACHE_TTL,
        };
    };
    const isFreshSearchCacheValue = (value: any) => {
        if (!value?.imoveis?.length) return false;

        const expiresAt = Number(value?.[SEARCH_CACHE_EXPIRES_AT_FIELD] || 0);
        return Number.isFinite(expiresAt) && expiresAt > Date.now();
    };
    const getFreshContextSearch = (path: string) => {
        if (getSearchSignature(ultimaConsulta || '') !== getSearchSignature(path || '')) {
            return null;
        }

        return isFreshSearchCacheValue(getOnlyQuery1) ? getOnlyQuery1 : null;
    };
    const normalizeSegmentForLookup = (value: unknown, keepPlusDelimiter = false) => {
        const rawValue = Array.isArray(value) ? value[0] : value;
        const source = String(rawValue ?? '');
        let decoded = source;
        try {
            decoded = decodeURIComponent(source);
        } catch {
            decoded = source;
        }

        let normalized = removerAcentos(decoded).toLowerCase();
        if (!keepPlusDelimiter) {
            normalized = normalized.replaceAll('+', ' ');
        }

        return normalized
            .replaceAll('%20', ' ')
            .replaceAll('---', '-002D-')
            .replaceAll('-', ' ')
            .replaceAll('002D', '-')
            .replaceAll('002d', '-')
            .replaceAll('\n', '-')
            .trim();
    };
    const normalizeLabelForLookup = (value: unknown) =>
        removerAcentos(String(value ?? ''))
            .toLowerCase()
            .replaceAll('\n', '-')
            .trim();
    const currentSearchSignature = getSearchSignature(currentAsPath || '');
    const initialCached = getFreshContextSearch(currentAsPath || '');

    const renderOnlyTextFilters1 = () => {
        const resposta = currentAsPath.split("/")
        if(categoryActual?.value){
            return categoryActual?.label
        }
        if(dataEntregaActual?.length > 0){
            return `Imóveis com entrega em ${dataEntregaActual?.map((tip: any) => {return tip?.value}).join(",")}`
        }
        if(promocao){
            return 'Promoções'
        }
        if(resposta[7]){
            return 'por código'
        }
        if(resposta[2] == "venda"){
            return 'à venda'
        }
        if(resposta[2] == "aluguel"){
            return 'para alugar'
        }
        if(resposta[2] == "temporada"){
            return 'para Temporada'
        }
        return 'à venda'
    };

    const renderOrdem = () => {
        const options=[
            {
                label: 'Mais Recentes',
                value: 'desc-inclusao',
            },
            {
                label: 'Mais Antigos',
                value: 'asc-inclusao',
            },
            {
                label: 'Maior Valor',
                value: 'desc-valor',
            },
            {
                label: 'Menor Valor',
                value: 'asc-valor',
            },
            {
                label: 'Mais Visitados',
                value: 'desc-visualizacao',
            },
            {
                label: 'Menos Visitados',
                value: 'asc-visualizacao',
            },
            {
                label: 'Exclusivos',
                value: 'asc-exclusivos',
            },
        ]

        const option = options.find(option => option.value === allDataHome?.site?.ordenar_lista);

        return {
            label: option?.label || "",
            value: allDataHome?.site?.ordenar_lista || "",
        }
    }

    const [newPath, setNewPath] = useState(currentAsPath);
    const getArraysPaths = newPath.split('?')[0].split('/');
    const [initialFlow, setInitialFlow] = useState<any>(['home','imóveis',...getArraysPaths.slice(2, getArraysPaths.length).filter((v: any) => !['asc', 'desc'].includes(v)),]);
    const valores: any = {precos_venda: [allDataHome?.precos_venda[0] || [{min:0,max:1000000}]], precos_locacao: [allDataHome?.precos_locacao[0] || [{min:0,max:100000}]]};
    const [allPropertiesMapa, setAllPropertiesMapa] = useState<any>([]);
    const [allProperties, setAllProperties] = useState<any>(initialCached?.imoveis || []);
    const [autorizaBusca, setAutorizaBusca] = useState<any>(false);

    const site = allDataHome?.site;
    const [typeActual, setTypeActual] = useState<Array<any>>([]);

    const [orderActual, setOrderActual] = useState<any>(ordem != undefined && ordem != site?.ordenar_lista ? 
        {
            label: String(ordem).replace("asc-","Menos ").replace("desc-","Mais ").replace("Inclusao","Recentes").replace("inclusao","Recentes").replace("Menos Exclusivos","Exclusivos"),
            value: String(ordem)
        }
            :
        renderOrdem()
    );
    const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
    const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;

    const initialValue = {
        suites_min: suites != undefined ? Number(suites) : 0,
        garagems_min: vagas != undefined ? Number(vagas) : 0,
        dormitorios_min: dormitorios != undefined ? Number(dormitorios) : 0,
        banheiros_min: banheiros != undefined ? Number(banheiros) : 0
    };
    const caracteristica = id_caracteristica != undefined ? id_caracteristica : "";
    const datas_entrega = data_entrega != undefined ? data_entrega : "";

    const [activeDrawer, setActiveDrawer] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<any>>([]);
    const [openFavoritos, setOpenFavoritos] = useState<boolean>(favoritos ? true : false)
    const [naoEncontrou, setNaoEncontrou] = useState<boolean>(false)
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [cityActual, setCityActual] = useState<any>(null);
    const [filtersInitialized, setFiltersInitialized] = useState(false);
    const [first, setFirst] = useState(false);
    const [categoryActual, setCategoryActual] = useState<any>(null);
    const [estadoActual, setEstadoActual] = useState<any>(null);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [codeActual, setCodeActual] = useState('');
    const [type, setType] = useState(currentAsPath.split("/")[2] == "temporada" ? 'temporada' : currentAsPath.split("/")[2] == "aluguel" ? 'rent' : 'sale');
    const [idAgenciador, setAgenciador] = useState<number>(agenciadorId);
    const [typeValidation, setTypeValidation] = useState(renderOnlyTextFilters1());
    const cor_detalhes = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13; 
    const isNovember = new Date().getMonth() === 10;

    const normalizePriceBounds = (bounds: any) => {
        const minValue = Number(bounds?.min);
        const maxValue = Number(bounds?.max);
        const normalizedMin = Number.isFinite(minValue) && minValue >= 0 ? minValue : 0;
        const normalizedMax = Number.isFinite(maxValue) && maxValue >= normalizedMin ? maxValue : normalizedMin;

        return {
            min: normalizedMin,
            max: normalizedMax,
        };
    };
    const getPriceBoundsForType = (currentType?: string | null) => {
        const normalizedType = String(currentType || '').toLowerCase();

        if (normalizedType === 'rent' || normalizedType === 'aluguel') {
            return normalizePriceBounds(valores?.precos_locacao?.[0]);
        }
        if (normalizedType === 'sale' || normalizedType === 'venda') {
            return normalizePriceBounds(valores?.precos_venda?.[0]);
        }
        if (normalizedType === 'temporada') {
            if (valores?.precos_locacao?.[0]?.max) {
                return normalizePriceBounds({ min: 0, max: valores?.precos_locacao?.[0]?.max });
            }

            return normalizePriceBounds({ min: 0, max: valores?.precos_venda?.[0]?.max });
        }

        const fallbackBounds = valores?.precos_venda?.[0]?.max > 0
            ? valores?.precos_venda?.[0]
            : valores?.precos_locacao?.[0];

        return normalizePriceBounds(fallbackBounds);
    };
    const resolvePriceRangeFromQuery = (bounds: any, rawMin: unknown, rawMax: unknown): [number, number] => {
        const safeBounds = normalizePriceBounds(bounds);
        const defaultRange: [number, number] = [safeBounds.min, safeBounds.max];
        const queryMin = parsePositiveQueryNumber(rawMin);
        const queryMax = parsePositiveQueryNumber(rawMax);

        if (!queryMin && !queryMax) {
            return defaultRange;
        }

        const nextMin = queryMin || safeBounds.min;
        const nextMax = queryMax || safeBounds.max;
        const isWithinBounds =
            nextMin >= safeBounds.min &&
            nextMin <= safeBounds.max &&
            nextMax >= safeBounds.min &&
            nextMax <= safeBounds.max;

        if (!isWithinBounds || nextMin > nextMax) {
            return defaultRange;
        }

        return [nextMin, nextMax];
    };
    const getFiltersPricess = getPriceBoundsForType(type);
    const minQueryValue = getRouteQueryValue(min, 'min');
    const maxQueryValue = getRouteQueryValue(max, 'max');
    const initialPriceRange = resolvePriceRangeFromQuery(getFiltersPricess, minQueryValue, maxQueryValue);
    const [filterPrice, setFilterPrice] = useState<any>(!getFiltersPricess?.min && !getFiltersPricess?.max ? { min: 0, max: 0 } : getFiltersPricess);
    const [price, setPrice] = useState<Array<number>>(initialPriceRange);
    const [area, setArea] = useState<Array<any>>(area_min || area_max ? [area_min ? area_min : 0,area_max ? area_max : 0] : [0,0]);
    const [page, setPage] = useState<number>(pagination ? Number(pagination) : 1);
    const [qtd, setQtd] = useState(initialCached?.count || 0);
    const [listDistrict, setListDistrict] = useState<any>([]);
    const listType = allDataHome?.tipos ? formatSelects(allDataHome?.tipos) : [];
    const [companyInputActual, setCompanyInputActual] = useState('');
    const [allUrl, setAllUrl] = useState('');
    const [loading, setLoading] = useState<any>(!initialCached?.imoveis?.length);
    const [listCacheExpiresAt, setListCacheExpiresAt] = useState<number>(
        Number(initialCached?.[SEARCH_CACHE_EXPIRES_AT_FIELD] || 0)
    );
    const [pendingScroll, setPendingScroll] = useState<number | null>(null);
    const scrollKeyRef = useRef<string>('');
    const scrollRestoreAttemptsRef = useRef(0);
    const scrollRestoreRafRef = useRef<number | null>(null);
    const initialUrlRef = useRef<string>('');
    const initialComparableRef = useRef<string>('');
    const userActionRef = useRef(false);
    const lastCardRef = useRef<any>(null);
    const [disableEntryMotion, setDisableEntryMotion] = useState(false);
    const [filters, setFilters] = useState<any>(initialValue);
    const [activeLargeFilter, setActiveLargeFilter] = useState(false);
    const allCities = allDataHome?.cidades ? formatSelects(allDataHome?.cidades,allDataHome?.site?.cidade_priorizada ) : [];
    const [listCity, setListCity] = useState<any>(allCities);
    const codsite1 = init_props?.codsite;
    const origin = init_props?.origemInit;
    const storageHost =
        init_props?.prodOrigin ||
        init_props?.origemInit ||
        site?.site ||
        (typeof window !== 'undefined' ? window.location.host : '');
    const storageCodsite = init_props?.codsite || site?.id || 0;
    const listCategoryStorageKey = getImoveisListCategoryStorageKey(storageHost, storageCodsite);
    const listStatesStorageKey = getImoveisListStatesStorageKey(storageHost, storageCodsite);
    const listDatasStorageKey = getImoveisListDatasStorageKey(storageHost, storageCodsite);
    const listCaracteristicasStorageKey = getImoveisListCaracteristicasStorageKey(storageHost, storageCodsite);
    const condosStorageKey = getHomeScopedStorageKey('condominios', storageHost, storageCodsite);
    const hasStateFilter = site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065;
    const searchEventRef = useRef<{ key: string; at: number } | null>(null);
    const latestListRequestRef = useRef<{ id: number; signature: string }>({ id: 0, signature: '' });
    const latestMapSignatureRef = useRef<string>('');
    const latestCompanyRequestRef = useRef(0);
    const seoTransaction = type === 'rent' ? 'aluguel' : type === 'temporada' ? 'temporada' : 'venda';
    const imoveisSeo = buildImoveisSeo({
        asPath: currentAsPath,
        site,
        allDataHome,
        query: router.query,
        overrides: {
            transaction: seoTransaction,
            city: cityActual?.label,
            districts: districtActual?.map((item: any) => item?.label),
            types: typeActual?.map((item: any) => item?.label),
            company: companyActual?.label,
            category: categoryActual?.label,
            code: codeActual,
            dormitorios: filters?.dormitorios_min,
            suites: filters?.suites_min,
            banheiros: filters?.banheiros_min,
            vagas: filters?.garagems_min,
            promocao: promocao == '1',
            favoritos: openFavoritos,
        },
    });
    const renderSeoIntro = () =>
        imoveisSeo?.intro ? (
            <p className={styles.seoDescription} style={{ color: cor_detalhes }}>
                {imoveisSeo.intro}
            </p>
        ) : null;

    const setSearchContextCache = (value: any) => {
        const valueWithTTL = withSearchCacheTTL(value);
        setGetOnlyQuery1(valueWithTTL);
        setListCacheExpiresAt(Number(valueWithTTL?.[SEARCH_CACHE_EXPIRES_AT_FIELD] || 0));
    };

    const expireSearchContextCache = () => {
        setGetOnlyQuery1([]);
        setListCacheExpiresAt(0);
        if (typeof window !== 'undefined') {
            localStorage.removeItem(getSearchCacheKey(currentAsPath || ''));
        }
    };

    const readLocalStorageValue = <T,>(key: string, fallback: T): T => {
        if (typeof window === 'undefined') return fallback;
        return readJsonStorageValue<T>(window.localStorage, key, fallback);
    };

    const readLocalArray = (key: string) => {
        const value = readLocalStorageValue<any>(key, []);
        return Array.isArray(value) ? value : [];
    };

    const withReadyDeliveryOption = (value: any) => {
        const options = Array.isArray(value) ? value.filter(Boolean) : [];
        const readyItem = { label: 'ImÃ³vel Pronto', value: 1 };
        const remaining = options.filter(
            (item: any) => !(item?.label === readyItem.label && item?.value === readyItem.value)
        );

        return [readyItem, ...remaining];
    };

    const buildCompanyOptions = (value: any, includeBlankOption = true) => {
        const source = Array.isArray(value?.empreendimentos)
            ? value.empreendimentos
            : Array.isArray(value)
                ? value
                : [];
        const options = source
            .map((item: any) => {
                if (!item) return null;

                if (item?.label !== undefined && item?.value !== undefined) {
                    return {
                        label: String(item.label || '').trim(),
                        value: item.value,
                        id_estado: item?.id_estado ? item.id_estado : 0,
                    };
                }

                if (item?.nome && item?.id) {
                    return {
                        label: String(item.nome).trim(),
                        value: item.id,
                        id_estado: item?.id_estado ? item.id_estado : 0,
                    };
                }

                return null;
            })
            .filter((item: any) => item && item.label && item.value !== null && item.value !== undefined);

        if (!includeBlankOption || options.length === 0) {
            return options;
        }

        return [{ label: '', value: null, id_estado: 0 }, ...options];
    };

    const warnStorageBootstrap = (scope: string, error: unknown) => {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(`[imoveis] falha ao inicializar storage em ${scope}`, error);
        }
    };

    const resetBootstrapLists = () => {
        if (site?.categoria_home) {
            setListCategory([]);
        }
        if (hasStateFilter) {
            setListEstados([]);
        }
        if (site?.mostrar_data_entrega) {
            setListDatas([]);
        }
        if (site?.caracteristicas_home) {
            setListCaracteristicas([]);
        }
    };

    const beginListRequest = (signature: string) => {
        const nextId = latestListRequestRef.current.id + 1;
        latestListRequestRef.current = { id: nextId, signature };
        return nextId;
    };

    const isLatestListRequest = (requestId: number, signature: string) => {
        return (
            latestListRequestRef.current.id === requestId &&
            latestListRequestRef.current.signature === signature
        );
    };

    useEffect(() => {
        if (pagination && Number(pagination) != page) {
            setPage(Number(pagination || 1));
        }
    }, [pagination]);

    const setAutorizaBuscaFromUser = (value: any) => {
        if (value) {
            userActionRef.current = true;
        }
        setAutorizaBusca(value);
    };

    useEffect(() => {
        if (!listCacheExpiresAt || typeof window === 'undefined') return;

        const refreshExpiredSearch = () => {
            expireSearchContextCache();
            if (router.isReady && filtersInitialized) {
                setLoading(true);
                setAutorizaBusca(true);
            }
        };
        const expiresInMs = listCacheExpiresAt - Date.now();

        if (expiresInMs <= 0) {
            refreshExpiredSearch();
            return;
        }

        const timeoutId = window.setTimeout(refreshExpiredSearch, expiresInMs);
        return () => window.clearTimeout(timeoutId);
    }, [listCacheExpiresAt, currentSearchSignature, router.isReady, filtersInitialized]);

    // methods
    useEffect(() => {
        if (favorito === null) {
            setOpenFavoritos(false)
        }
    }, [favorito]);

    useEffect(() => {
        if (!initialUrlRef.current) {
            const raw = currentAsPath || '';
            initialUrlRef.current = raw;
            initialComparableRef.current = getSearchSignature(raw);
        }
    }, [currentAsPath]);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const raw = sessionStorage.getItem('imoveis:lastCard');
        if (!raw) {
            lastCardRef.current = null;
            setDisableEntryMotion(false);
            return;
        }
        try {
            lastCardRef.current = JSON.parse(raw);
            const currentComparable = getSearchSignature(currentAsPath || '');
            const lastComparable = getSearchSignature(lastCardRef.current?.path || '');
            setDisableEntryMotion(currentComparable === lastComparable);
        } catch {
            lastCardRef.current = null;
            setDisableEntryMotion(false);
        }
    }, [currentAsPath]);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const key = `imoveis:scroll:${normalizePath(currentAsPath || '')}`;
        scrollKeyRef.current = key;

        const saved = sessionStorage.getItem(key);
        if (saved) {
            const parsed = Number(saved);
            if (!Number.isNaN(parsed)) {
                setPendingScroll(parsed);
            }
        }

        const hasScrollRestoration = 'scrollRestoration' in window.history;
        const prevRestoration = hasScrollRestoration
            ? window.history.scrollRestoration
            : 'auto';
        if (hasScrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }

        return () => {
            if (hasScrollRestoration) {
                window.history.scrollRestoration = prevRestoration;
            }
            const y = window.scrollY || 0;
            sessionStorage.setItem(key, String(y));
        };
    }, [currentAsPath]);

    useEffect(() => {
        if ((pendingScroll === null && !lastCardRef.current) || loading) return;

        scrollRestoreAttemptsRef.current = 0;

        const attemptRestore = () => {
            const maxScroll = Math.max(
                0,
                document.documentElement.scrollHeight - window.innerHeight
            );

            const lastCard = lastCardRef.current;
            const cardEl = lastCard?.id
                ? document.getElementById(`imovel-card-${lastCard?.id}`)
                : null;
            const cardTarget = cardEl
                ? Math.max(
                    0,
                    cardEl.getBoundingClientRect().top +
                        window.scrollY -
                        (lastCard?.viewportTop ?? 0)
                )
                : null;

            const scrollTarget = pendingScroll ?? 0;
            const target = cardTarget !== null ? cardTarget : Math.min(Math.max(0, scrollTarget), maxScroll);
            const ready = maxScroll + 8 >= target;

            if ((ready || scrollRestoreAttemptsRef.current >= 40) && target !== null) {
                window.scrollTo({ top: target, behavior: 'auto' });
                if (scrollKeyRef.current) {
                    sessionStorage.removeItem(scrollKeyRef.current);
                }
                if (cardEl) {
                    sessionStorage.removeItem('imoveis:lastCard');
                    lastCardRef.current = null;
                }
                setDisableEntryMotion(false);
                setPendingScroll(null);
                scrollRestoreAttemptsRef.current = 0;
                return;
            }

            if (scrollRestoreAttemptsRef.current >= 40) {
                if (lastCardRef.current) {
                    sessionStorage.removeItem('imoveis:lastCard');
                    lastCardRef.current = null;
                }
                setDisableEntryMotion(false);
                setPendingScroll(null);
                scrollRestoreAttemptsRef.current = 0;
                return;
            }

            scrollRestoreAttemptsRef.current += 1;
            scrollRestoreRafRef.current = requestAnimationFrame(attemptRestore);
        };

        scrollRestoreRafRef.current = requestAnimationFrame(attemptRestore);

        return () => {
            if (scrollRestoreRafRef.current) {
                cancelAnimationFrame(scrollRestoreRafRef.current);
            }
        };
    }, [pendingScroll, loading, allProperties?.length, currentAsPath]);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (allProperties?.length > 0) return;

        const pathNow = getSearchSignature(currentAsPath || '');
        const cached = getCachedSearch(currentAsPath || '');
        if (cached?.imoveis?.length > 0) {
            setAllProperties(cached.imoveis);
            setQtd(cached.count || 0);
            setSearchContextCache(cached);
            if (!ultimaConsulta) {
                setUltimaConsulta(pathNow);
            }
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if(newPath){
            const getArraysPaths = newPath.split('?')[0].split('/');
            setInitialFlow([
                'home',
                'imóveis',
                ...getArraysPaths
                    .slice(2, getArraysPaths.length)
                    .filter((v: any) => !['asc', 'desc'].includes(v)),
            ]);
        }
    }, [newPath]);

    useEffect(() => {
        if (!router.isReady) return;

        const timeOutId = setTimeout(() => {
            GetInitialFilters();
        }, 500);

        return () => clearTimeout(timeOutId);
    }, [router.isReady, currentSearchSignature]);

    const GetInitialFilters2 = async () => {
        try {
        if(listCategory === 0 && site?.categoria_home){
            const getCondo: any = readLocalArray(listCategoryStorageKey);

            if(getCondo?.length > 0){
                setListCategory(getCondo);
                if(Number.isInteger(categoria) && categoria > 0){
                    const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === categoria);
                    if(objeto){
                        setCategoryActual(objeto)
                    }
                }
            } else {
                const infoCategory = await categorias(origin, codsite1);
                if(infoCategory){
                    const formatCategorias = formatSelects(infoCategory?.categorias);
                    if(formatCategorias?.length > 0){
                        if(Number.isInteger(categoria) && categoria > 0){
                            const objeto = formatCategorias.find((item: { label: string; value: number; }) => item.value === categoria);
                            if(objeto){
                                setCategoryActual(objeto)
                            }
                        }
                        localStorage.setItem(listCategoryStorageKey, JSON.stringify(formatCategorias));
                        setListCategory(formatCategorias);
                    }
                    else
                        setListCategory([]);
                }
                
            }
        } else {
            if(Number.isInteger(categoria) && categoria > 0 && listCategory && !autorizaBusca){
                const getCondo = listCategory || []
                const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === categoria);
                if(objeto){
                    setCategoryActual(objeto)
                }
            }
        }

        if(listEstados === 0 && hasStateFilter){
            const getCondo: any = readLocalArray(listStatesStorageKey);
   
            if(getCondo?.length > 0){
                setListEstados(getCondo);
                if(Number.isInteger(id_estado) && id_estado > 0){
                    const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === id_estado);
                    if(objeto){
                        setEstadoActual(objeto)
                        if(objeto.value > 0){
                            const cidadesFiltradas = allCities.filter(
                                (city: { id_estado: any; }) => city?.id_estado === objeto.value
                            );
                
                            setListCity(cidadesFiltradas)
                        }
                    }
                }
            } else {
                const infoCategory = await get_estados(origin, codsite1);
                if(infoCategory){
                    const formatCategorias = site?.id == 2065 ? formatSelectsEstados(infoCategory?.estados) : formatSelects(infoCategory?.estados);
                    if(formatCategorias?.length > 0){
                        if(Number.isInteger(id_estado) && id_estado > 0){
                            const objeto = formatCategorias.find((item: { label: string; value: number; }) => item.value === id_estado);
                            if(objeto){
                                setEstadoActual(objeto)

                                if(objeto.value > 0){
                                    const cidadesFiltradas = allCities.filter(
                                        (city: { id_estado: any; }) => city?.id_estado === objeto.value
                                    );
                        
                                    setListCity(cidadesFiltradas)
                                }
                            }
                        }
                        localStorage.setItem(listStatesStorageKey, JSON.stringify(formatCategorias));
                        setListEstados(formatCategorias);
                    } else {
                        setListEstados([]);
                    }
                }
            }
        } else {
            if(Number.isInteger(id_estado) && id_estado > 0 && listEstados){
                const getCondo = listEstados || []
                const objeto = getCondo.find((item: { label: string; value: number; }) => item.value === id_estado);
                if(objeto){
                    setEstadoActual(objeto)
                }
            }
        }

        if(listDatas === 0 && site?.mostrar_data_entrega){
            const getCondo: any = readLocalArray(listDatasStorageKey);

            if(getCondo?.length > 0){
                const normalizedDatas = withReadyDeliveryOption(getCondo);
                setListDatas(normalizedDatas);
                if(datas_entrega){
                    const DatasArray = String(datas_entrega)
                        ?.split(',')                       // Dividir a string por vírgula
                        .map(str => str.trim())             // Remover espaços extras
                        .map(Number)                        // Converter cada item para número
                        .filter(num => !isNaN(num));        // Filtrar valores que não são números
                    const GetOnlyDatas = normalizedDatas?.filter((e: any) => {
                        return DatasArray.includes(e.value);
                    });

                    setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
                }
            } else {
                const infoDatas = await allDatasEntrega(origin, codsite1);
                const formatDatas = Array.isArray(infoDatas?.datas_entrega)
                    ? withReadyDeliveryOption(formatSelectsTransacao(infoDatas.datas_entrega))
                    : [];
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                void newItem;
                if(formatDatas?.length > 0){
                    if(datas_entrega){
                        const DatasArray = String(datas_entrega)
                            ?.split(',')                       // Dividir a string por vírgula
                            .map(str => str.trim())             // Remover espaços extras
                            .map(Number)                        // Converter cada item para número
                            .filter(num => !isNaN(num));        // Filtrar valores que não são números

                        // Passo 2: Filtrar o array 'getCondo' usando os valores do array de características
                        const GetOnlyDatas = formatDatas?.filter((e: any) => {
                            return DatasArray.includes(e.value);
                        });

                        setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
                    }
                    setListDatas(formatDatas);
                    localStorage.setItem(listDatasStorageKey, JSON.stringify(formatDatas));
                }
                else
                    setListDatas([]);
            }
        } else {
            if(datas_entrega && listDatas){
                const getCondo: any = listDatas || []
                const DatasArray = String(datas_entrega)
                    ?.split(',')                       // Dividir a string por vírgula
                    .map(str => str.trim())             // Remover espaços extras
                    .map(Number)                        // Converter cada item para número
                    .filter(num => !isNaN(num));        // Filtrar valores que não são números
                const GetOnlyDatas = getCondo?.filter((e: any) => {
                    return DatasArray.includes(e.value);
                });

                setDataEntregaActual(GetOnlyDatas ? GetOnlyDatas : []);
            }
        }

        if(listCaracteristicas === 0 && site?.caracteristicas_home){
            const getCondo = getWithTTL<any>(listCaracteristicasStorageKey);

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
                if(caracteristica){
                    const caracteristicasArray = String(caracteristica)
                        ?.split(',')                       // Dividir a string por vírgula
                        .map(str => str.trim())             // Remover espaços extras
                        .map(Number)                        // Converter cada item para número
                        .filter(num => !isNaN(num));        // Filtrar valores que não são números

                    const GetOnlyCar = getCondo?.filter((e: any) => {
                        return caracteristicasArray.includes(e.value);
                    });

                    setCaractActual(GetOnlyCar ? GetOnlyCar : []);
                }
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite1);
                const formatCarac = formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);

                    if(caracteristica){
                        const caracteristicasArray = String(caracteristica)
                            ?.split(',')                       // Dividir a string por vírgula
                            .map(str => str.trim())             // Remover espaços extras
                            .map(Number)                        // Converter cada item para número
                            .filter(num => !isNaN(num));        // Filtrar valores que não são números

                        // Passo 2: Filtrar o array 'getCondo' usando os valores do array de características
                        const GetOnlyCar = formatCarac?.filter((e: any) => {
                            return caracteristicasArray.includes(e.value);
                        });

                        setCaractActual(GetOnlyCar ? GetOnlyCar : []);
                    }
                    const DAY_MS = 24 * 60 * 60 * 1000; // 86_400_000
                    setWithTTL(listCaracteristicasStorageKey, formatCarac, DAY_MS);
                }
                else
                setListCaracteristicas([]);
            }
        } else {
            if(caracteristica && listCaracteristicas){
                const getCaract: any = listCaracteristicas || []
                const caracteristicasArray = String(caracteristica)
                    ?.split(',')                       // Dividir a string por vírgula
                    .map(str => str.trim())             // Remover espaços extras
                    .map(Number)                        // Converter cada item para número
                    .filter(num => !isNaN(num));        // Filtrar valores que não são números

                const GetOnlyCar = getCaract?.filter((e: any) => {
                    return caracteristicasArray.includes(e.value);
                });

                setCaractActual(GetOnlyCar ? GetOnlyCar : []);
            }
        }
        } catch (error) {
            warnStorageBootstrap('GetInitialFilters2', error);
            resetBootstrapLists();
        } finally {
            setAutorizaBusca(true);
        }
    }

    const GetInitialFilters = async () => {
        if (!router.isReady) return;

        try {
        let formatType = listType;
        let formatCities = allCities;

        if (agenciadorId > 0) {
            setAgenciador(agenciadorId);
        }
        const pathNow = getSearchSignature(currentAsPath || '');
        const hasContextCache = !!getFreshContextSearch(pathNow);
        const hasStorageCache =
            !hasContextCache &&
            typeof window !== 'undefined' &&
            !!getCachedSearch(currentAsPath || '')?.imoveis?.length;
        if (!hasContextCache && !hasStorageCache) {
            setLoading(true);
        }
        if(banheiros || dormitorios || vagas || suites) {
            setFilters({'suites_min': Number(suites) || 0, 'garagems_min': Number(vagas) || 0, 'dormitorios_min': Number(dormitorios) || 0, 'banheiros_min': Number(banheiros) || 0})
        }

        if(hasStateFilter){
            if(id_estado > 0){
                const cidadesFiltradas = allCities.filter(
                    (city: { id_estado: number; }) => city?.id_estado === id_estado
                );
    
                setListCity(cidadesFiltradas)
            } else {
                if(estadoActual?.value){
                    const cidadesFiltradas = allCities.filter(
                        (city: { id_estado: any; }) => city?.id_estado === estadoActual?.value
                    );
        
                    setListCity(cidadesFiltradas)
                } else {
                    setListCity(allCities);
                }
            }
        }

        let GetOnlyType = null;
        let getCity: any = null;
        let getDistrict = null;
        // let GetOnlyCompany = null;
        const query_type = router.query?.type != '[type]' ? router.query?.type || '-' : '-'
        const query_city = router.query?.city != '[city]' ? router.query?.city || '-' : '-'
        const query_district = router.query?.district != '[district]' ? router.query?.district || '-' : '-'
        const query_company = router.query?.company != '[company]' ? router.query?.company : '-'
        const query_transacao = router.query?.model == 'venda' || router.query?.model == 'aluguel' || router.query?.model == 'temporada' ? router.query?.model : 'venda'
        const getFiltersPrices1 = getPriceBoundsForType(query_transacao);
        const resolvedPriceRange = resolvePriceRangeFromQuery(
            getFiltersPrices1,
            getRouteQueryValue(min, 'min'),
            getRouteQueryValue(max, 'max')
        );

        if (filterPrice?.min !== getFiltersPrices1?.min || filterPrice?.max !== getFiltersPrices1?.max) {
            setFilterPrice(getFiltersPrices1);
        }
        if (price[0] !== resolvedPriceRange[0] || price[1] !== resolvedPriceRange[1]) {
            setPrice(resolvedPriceRange);
        }
        
        if (query_type && query_type != "-") {
            const typeTokens = normalizeSegmentForLookup(query_type, true)
                .split('+')
                .map((token) => token.trim())
                .filter(Boolean);
            GetOnlyType = formatType?.filter((e: any) => {
                return typeTokens.includes(normalizeLabelForLookup(e?.label));
            });
            setTypeActual(GetOnlyType ? GetOnlyType : []);
        } else {
            setTypeActual([])
        }

        if (query_city && query_city != "-") {
            const queryCityNormalized = normalizeSegmentForLookup(query_city);
            getCity = formatCities.find(
                (v: any) =>
                    normalizeLabelForLookup(v?.label) === queryCityNormalized
            );
            if(getCity){
                setCityActual(getCity);
                const infoDistrict = await district(Number(getCity?.value || -1), origin, codsite1);
                if(infoDistrict){
                    const formatListDistrict = formatSelects(infoDistrict?.bairros);
                    setListDistrict(formatListDistrict);
                    if(query_district && query_district != "-"){
                        const districtTokens = normalizeSegmentForLookup(query_district, true)
                            .split('+')
                            .map((token) => token.trim())
                            .filter(Boolean);
                        getDistrict = formatListDistrict.filter((v: any) => {
                            return districtTokens.includes(normalizeLabelForLookup(v?.label));
                        });
                        setDistrictActual(getDistrict ? getDistrict : []);
                    }
                }
            }
        } else {
            setCityActual(null)
        }
        if (query_company && query_company != '-') {
            // Fazer request pegando aquele nome do condominio
            const companyFormat = normalizeSegmentForLookup(query_company);
            const infoCompany: any = await getCompany(companyFormat, origin, codsite1);

            if (infoCompany?.empreendimentos?.length) {
                const formatCompany = await formatSelects(
                    infoCompany?.empreendimentos
                );
                // Pegar o primeiro elemento caso tenham dois com o mesmo nome
                if (formatCompany?.length > 0) {
                    setCompanyActual({
                        label: formatCompany[0]?.label,
                        value: formatCompany[0]?.value,
                    });
                } else {
                    setCompanyActual(0);
                }
            } else {
                setCompanyActual(0);
            }
        } else {
            setCompanyActual(0);
        }

        if (router.query?.code) {
            setCodeActual(String(router.query?.code).replaceAll("%20"," "));
        } else {
            setCodeActual('')
        }
        if(transacao != undefined && transacao && site?.transacoes){
            setType(JSON.stringify(transacao))
        }else{
            if (query_transacao === 'aluguel') {
                setType('rent');
            } else {
                if(query_transacao === 'venda'){
                    setType('sale');
                } else {
                    setType('temporada');
                }
            }
        }
        setFiltersInitialized(true)
        if(site?.caracteristicas_home || site?.categoria_home || site?.mostrar_data_entrega || hasStateFilter){
            await GetInitialFilters2()
        } else {
            setAutorizaBusca(true)
        }
        } catch (error) {
            warnStorageBootstrap('GetInitialFilters', error);
            resetBootstrapLists();
            setFiltersInitialized(true);
            setAutorizaBusca(true);
        }
    };

    const zeraFiltros = () => {
        setPage(1)
        setCityActual(null)
        setTypeActual([])
        setCaractActual([])
        setDistrictActual([])
        setType("sale")
        setFilters([])
        setAgenciador(0)
        setPrice([filterPrice?.min,filterPrice?.max]);
        setCompanyActual(0)
        setCategoryActual(null)
        setDataEntregaActual([])
        setFiltersInitialized(true)
        setAutorizaBusca(true)
    }

    const GetInitial = async (newPage?: boolean) => {
        if (!router.isReady) return;

        const verifyPage = () => {
            if (page) {
                return page;
            }
            return 1;
        };

        const query_type = router.query?.type != '[type]' ? router.query?.type || '-' : '-'
        const query_city = router.query?.city != '[city]' ? router.query?.city || '-' : '-'
        const query_district = router.query?.district != '[district]' ? router.query?.district || '-' : '-'
        const query_company = router.query?.company != '[company]' ? router.query?.company : '-'
        const pageActual = verifyPage();
        let buscou = 0;
        const agenciadorQuery = agenciadorId > 0 ? agenciadorId : (Number(idAgenciador) || 0);

        const trans = type == "sale" ? "venda" : type == "rent" ? "aluguel" : type == "temporada" ? "temporada" : router.query?.model == 'venda' || router.query?.model == 'aluguel' || router.query?.model == 'temporada' ? router.query?.model : 'venda';
        let newPathForm = `/imoveis/${trans}/${
            cityActual?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-') || '-'
        }/${
            districtActual
                ?.map((e) => e?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-'))
                ?.join()
                ?.replaceAll(',', '+') || '-'
        }/${
            companyActual?.label
                ? companyActual?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-')
                : '-'
        }/${
            typeActual
                ?.map((e) => e?.label?.replaceAll('-', '002D')?.replaceAll(' ', '-')?.replaceAll("\n", '-'))
                ?.join()
                ?.replaceAll(',', '+') || '-'
        }${
            codeActual ? `/${codeActual?.replaceAll(' ', '%20')}` : ''
        }`?.replaceAll(' ', '');
        
        if (!window.location.pathname.includes('/novidades')) {
            if(removerAcentos(newPathForm).toLowerCase() != newPath)
                setNewPath(removerAcentos(newPathForm).toLowerCase());

            if(categoryActual?.value || caractActual?.length > 0 || dataEntregaActual?.length > 0 || codsite || id_estado > 0 || categoria > 0 || area[0] || area[1] || price[0] || price[1] || utm_source || utm_medium || utm_id || utm_campaign || filters.suites_min || filters.dormitorios_min || filters.garagems_min || filters.banheiros_min || openFavoritos || promocao == "1" || agenciadorQuery > 0){
                newPathForm = newPathForm+'?filtros'
                if(price[0] || price[1]){
                    newPathForm = newPathForm+'&min='+price[0]+'&max='+price[1]
                }
                if(area[0] || area[1]){
                    newPathForm = newPathForm+'&area_min='+area[0]+'&area_max='+area[1]
                }
                if(categoryActual?.value){
                    newPathForm = newPathForm+'&categoria='+categoryActual?.value
                } 
                if(estadoActual?.value){
                    newPathForm = newPathForm+'&id_estado='+estadoActual?.value
                } else {
                    if(id_estado > 0){
                        newPathForm = newPathForm+'&id_estado='+id_estado
                    }
                }
                if(dataEntregaActual?.length > 0){
                    newPathForm = newPathForm + '&data_entrega='+dataEntregaActual?.map((tip: any) => {return tip?.value}).join(",");
                } else {
                    if(datas_entrega){
                        newPathForm = newPathForm+'&data_entrega='+datas_entrega
                    }
                }
                if(codsite){
                    newPathForm = newPathForm+'&codsite='+codsite
                }
                if(promocao){
                    newPathForm = newPathForm+'&promocao=1'
                }
                if(utm_source){
                    newPathForm = newPathForm+'&utm_source='+utm_source
                }
                if(utm_medium){
                    newPathForm = newPathForm+'&utm_medium='+utm_medium
                }
                if(utm_id){
                    newPathForm = newPathForm+'&utm_id='+utm_id
                }
                if(utm_campaign){
                    newPathForm = newPathForm+'&utm_campaign='+utm_campaign
                }
                if(agenciadorQuery > 0){
                    newPathForm = newPathForm+'&agenciador='+agenciadorQuery
                }
                if(filters.suites_min){
                    newPathForm = newPathForm+'&suites='+filters.suites_min
                }
                if(filters.dormitorios_min){
                    newPathForm = newPathForm+'&dormitorios='+filters.dormitorios_min
                }
                if(filters.garagems_min){
                    newPathForm = newPathForm+'&vagas='+filters.garagems_min
                }
                if(filters.banheiros_min){
                    newPathForm = newPathForm+'&banheiros='+filters.banheiros_min
                }
                if(orderActual?.value){
                    newPathForm = newPathForm+'&ordem='+orderActual?.value
                }
                if(pageActual){
                    newPathForm = newPathForm+'&pagination='+pageActual
                }
                if(caractActual?.length > 0){
                    newPathForm = newPathForm + '&id_caracteristica='+caractActual?.map((tip: any) => {return tip?.value}).join(",");
                } else {
                    if(caracteristica){
                        newPathForm = newPathForm+'&id_caracteristica='+caracteristica
                    }
                }

                if((favorito?.length > 0 || favoritos) && openFavoritos){
                    newPathForm = newPathForm+'&favoritos='+JSON.stringify(favorito).replaceAll("[","").replaceAll("]","")
                }
            }
        }

        const normalizedNewPathForm = normalizePath(newPathForm);
        const searchSignature = getSearchSignature(newPathForm);
        const cacheKey = getSearchCacheKey(newPathForm);
        const lastSearchSignature = getSearchSignature(ultimaConsulta || '');
        let requestId = 0;

        if((lastSearchSignature == "" || searchSignature != lastSearchSignature || first || allProperties?.length == 0) && filterPrice?.max > 0 && ((companyActual?.value || query_company == "-" || query_company == undefined) &&
        (typeActual?.length > 0 || query_type == '-' || query_type == undefined) &&
        (cityActual?.value > 0 || query_city == '-' || query_city == undefined) &&
        (districtActual.length > 0 || query_district == '-' || query_district == undefined) || filtersInitialized)) {
            if(!filtersInitialized)
                setFiltersInitialized(true)

            setFirst(true)

            if (searchSignature != lastSearchSignature)
                setUltimaConsulta(searchSignature)

            requestId = beginListRequest(searchSignature)

            let GetFilters
            let getOnlyQuery

            const freshContextCache = getFreshContextSearch(searchSignature);
            if(lastSearchSignature == searchSignature && freshContextCache){
                GetFilters = freshContextCache
                getOnlyQuery = freshContextCache;
            } else {
                const getImo = getCachedSearch(newPathForm);
                if(getImo?.imoveis?.length > 0){
                    GetFilters = getImo
                    getOnlyQuery = getImo;
                } else {
                    if(promocao == "1"){
                        GetFilters = await propertiesFilterPromocao(
                            categoryActual?.value ? categoryActual?.value : 0,
                            pageActual,
                            cityActual?.value,
                            districtActual.length > 0
                                ? JSON.stringify(districtActual.map((v) => v?.value))
                                : null,
                            typeActual.length > 0
                                ? JSON.stringify(typeActual.map((v) => v?.value))
                                : null,
                            JSON.stringify(codeActual),
                            type == 'sale'
                                ? Number(price[0])
                                : 0,
                            type == 'sale'
                                ? Number(price[1])
                                : null,
                            type == 'rent'
                                ? Number(price[0])
                                : 0,
                            type == 'rent'
                                ? Number(price[1])
                                : null,
                            type == 'sale' ? 1 : 0,
                            type == 'rent' ? 1 : 0,
                            companyActual?.value,
                            orderActual,
                            Number(filters.garagems_min || 0),
                            Number(filters.dormitorios_min || 0),
                            Number(filters.suites_min || 0),
                            Number(filters.banheiros_min || 0),
                            agenciadorQuery,
                            type == 'temporada'
                                ? Number(price[0])
                                : 0,
                            type == 'temporada'
                                ? Number(price[1])
                                : null,
                            type == 'temporada' ? 1 : 0,
                            openFavoritos ? apenasArray(favorito) : '',
                            origin,
                            codsite1
                        );

                        getOnlyQuery = ['Valor', 'Valor'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_promocao
                        : ['Visualizacao', 'Visualizacao'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_promocao
                        : GetFilters?.imoveis_promocao;
                    } else {
                        GetFilters = await propertiesFilter(
                            categoryActual?.value ? categoryActual?.value : 0,
                            pageActual,
                            cityActual?.value,
                            districtActual.length > 0
                                ? JSON.stringify(districtActual.map((v) => v?.value))
                                : null,
                            typeActual.length > 0
                                ? JSON.stringify(typeActual.map((v) => v?.value))
                                : null,
                            JSON.stringify(codeActual),
                            type === 'sale' || type === 'temporada'
                                ? Number(price[0])
                                : 0,
                            type === 'sale' || type === 'temporada'
                                ? Number(price[1])
                                : null,
                            type === 'rent'
                                ? Number(price[0])
                                : 0,
                            type === 'rent'
                                ? Number(price[1])
                                : null,
                            type === 'sale' ? 1 : 0,
                            type === 'rent' ? 1 : 0,
                            companyActual?.value,
                            orderActual,
                            Number(filters.garagems_min || 0),
                            Number(filters.dormitorios_min || 0),
                            Number(filters.suites_min || 0),
                            Number(filters.banheiros_min || 0),
                            agenciadorQuery,
                            type === 'temporada'
                                ? Number(price[0])
                                : 0,
                            type === 'temporada'
                                ? Number(price[1])
                                : null,
                            type === 'temporada' ? 1 : 0,
                            openFavoritos ? apenasArray(favorito) : '',
                            origin,
                            codsite1,
                            caractActual.length > 0
                            ? JSON.stringify(caractActual.map((v) => v?.value))
                            : 0,
                            area[0] >= 0 ? area[0] : 0,
                            area[1] > 0 ? area[1] : 0,
                            0,
                            dataEntregaActual.length > 0
                            ? JSON.stringify(dataEntregaActual.map((v) => v?.value))
                            : 0,
                            estadoActual?.value > 0
                            ? estadoActual?.value
                            : 0
                        );

                        getOnlyQuery = ['Valor', 'Valor'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_busca
                        : ['Visualizacao', 'Visualizacao'].includes(orderActual?.label)
                        ? GetFilters?.imoveis_busca
                        : GetFilters?.imoveis_busca;
                    }
                }
            }

            if (!isLatestListRequest(requestId, searchSignature)) {
                return;
            }

            const currentRawPath = currentAsPath || '';
            const currentComparable = getSearchSignature(currentRawPath);
            const initialComparable = initialComparableRef.current || currentComparable;
            const preserveInitial =
                currentRawPath === initialUrlRef.current &&
                searchSignature === initialComparable;

            if (!userActionRef.current) {
                setAllUrl(normalizedNewPathForm);
            } else if (preserveInitial) {
                setAllUrl(normalizedNewPathForm);
            } else if (searchSignature !== currentComparable) {
                router.push(normalizedNewPathForm, undefined, { shallow: true, scroll: false });
                setAllUrl(normalizedNewPathForm);
            } else {
                setAllUrl(normalizedNewPathForm);
            }

            if (!isLatestListRequest(requestId, searchSignature)) {
                return;
            }

            setSearchContextCache(getOnlyQuery)
            if (getOnlyQuery?.imoveis?.length > 0) {
                setWithTTL(cacheKey, getOnlyQuery, LIST_CACHE_TTL);
                buscou =1;
                setNaoEncontrou(false)
                setLoading(false)
                setAllProperties(getOnlyQuery?.imoveis);
                setQtd(getOnlyQuery?.count);
                if (typeValidation) {
                    if(codeActual?.length >= 2) {
                        if(typeValidation != 'por código'){
                            setTypeValidation('por código');
                        }
                    }else{
                        if (type === 'sale') {
                            if(typeValidation != 'à venda'){
                                setTypeValidation('à venda');
                            }
                        }
                        if (type === 'rent') {
                            if(typeValidation != 'para alugar'){
                                setTypeValidation('para alugar');
                            }
                        }
                        if (type === 'temporada') {
                            if(typeValidation != 'para Temporada'){
                                setTypeValidation('para Temporada');
                            }
                        }
                    }
                } else {
                    if(typeValidation != renderOnlyTextFilters1()){
                        setTypeValidation(renderOnlyTextFilters1());
                    }
                }
            } else {
                latestMapSignatureRef.current = ''
                setNaoEncontrou(true)
                setQtd(0)
                setLoading(true)
                setAllProperties([])
                setAllPropertiesMapa([])
            }
        } else {
            latestMapSignatureRef.current = ''
            if (allProperties?.length > 0) {
                setLoading(false);
                return;
            }
            setAllProperties([]);
            setAllPropertiesMapa([])
            setQtd(0);

            if(codeActual?.length >= 2) {
                if(typeValidation != 'por código'){
                    setTypeValidation('por código');
                }
            }else{
                if (type === 'sale') {
                    if(typeValidation != 'à venda'){
                        setTypeValidation('à venda');
                    }
                }
                if (type === 'rent') {
                    if(typeValidation != 'para alugar'){
                        setTypeValidation('para alugar');
                    }
                }
                if (type === 'temporada') {
                    if(typeValidation != 'para Temporada'){
                        setTypeValidation('para Temporada');
                    }
                }
            }

            if (newPage && typeof newPage === 'boolean' && page > 1) {
                setPage(page - 1);
                // alert('Não há mais imóveis nas próximas páginas');
            }
        }
        if(site?.mostrar_mapa && site?.mostrar_mapa != undefined && buscou == 1) {
            const shouldFetchMap = latestMapSignatureRef.current !== searchSignature;
            if (!shouldFetchMap) {
                return;
            }

            let GetPropertiesMap
            if(promocao == "1"){
                GetPropertiesMap = await propertiesMapaPromocao(
                    categoryActual?.value ? categoryActual?.value : 0,
                    1,
                    cityActual?.value,
                    districtActual.length > 0
                        ? JSON.stringify(districtActual.map((v) => v?.value))
                        : null,
                    typeActual.length > 0
                        ? JSON.stringify(typeActual.map((v) => v?.value))
                        : null,
                    JSON.stringify(codeActual),
                    type === 'sale'
                        ? Number(price[0])
                        : 0,
                    type === 'sale'
                        ? Number(price[1])
                        : null,
                    type === 'rent'
                        ? Number(price[0])
                        : 0,
                    type === 'rent'
                        ? Number(price[1])
                        : null,
                    type === 'sale' ? 1 : 0,
                    type === 'rent' ? 1 : 0,
                    companyActual?.value,
                    orderActual,
                    Number(filters.garagems_min || 0),
                    Number(filters.dormitorios_min || 0),
                    Number(filters.suites_min || 0),
                    Number(filters.banheiros_min || 0),
                    agenciadorQuery,
                    type === 'temporada' ? 1 : 0,
                    100,
                    origin,
                    codsite1
                );

                if (!isLatestListRequest(requestId, searchSignature)) {
                    return;
                }

                latestMapSignatureRef.current = searchSignature;
                if(GetPropertiesMap?.imoveis_promocao?.count > 0){
                    setAllPropertiesMapa(GetPropertiesMap?.imoveis_promocao?.imoveis)
                } else {
                    setAllPropertiesMapa([])
                }
            } else {
                GetPropertiesMap = await propertiesMapa(
                    categoryActual?.value ? categoryActual?.value : 0,
                    1,
                    cityActual?.value,
                    districtActual.length > 0
                        ? JSON.stringify(districtActual.map((v) => v?.value))
                        : null,
                    typeActual.length > 0
                        ? JSON.stringify(typeActual.map((v) => v?.value))
                        : null,
                    JSON.stringify(codeActual),
                    type === 'sale'
                        ? Number(price[0])
                        : 0,
                    type === 'sale'
                        ? Number(price[1])
                        : null,
                    type === 'rent'
                        ? Number(price[0])
                        : 0,
                    type === 'rent'
                        ? Number(price[1])
                        : null,
                    type === 'sale' ? 1 : 0,
                    type === 'rent' ? 1 : 0,
                    companyActual?.value,
                    orderActual,
                    Number(filters.garagems_min || 0),
                    Number(filters.dormitorios_min || 0),
                    Number(filters.suites_min || 0),
                    Number(filters.banheiros_min || 0),
                    agenciadorQuery,
                    type === 'temporada' ? 1 : 0,
                    100,
                    origin,
                    codsite1
                );

                if (!isLatestListRequest(requestId, searchSignature)) {
                    return;
                }

                latestMapSignatureRef.current = searchSignature;
                if(GetPropertiesMap?.imoveis?.count > 0){
                    setAllPropertiesMapa(GetPropertiesMap?.imoveis?.imoveis)
                } else {
                    setAllPropertiesMapa([])
                }
            }
        }
    };

    const applyFilter = () => {
        setLoading(true);
        if(filtersInitialized){
            void GetInitial();
        }
        setActiveLargeFilter(false);
    };

    const GetAllCompany = async (nameCompany = '', requestId?: number) => {
        const infoCompany = await getCompany(nameCompany, origin, codsite1);

        if (requestId && latestCompanyRequestRef.current !== requestId) return;

        const companyOptions = buildCompanyOptions(infoCompany);
        setAllCompany(companyOptions);
        localStorage.setItem(condosStorageKey, JSON.stringify(companyOptions));
    };

    const concatLabels = (value: Array<any>) => {
        if (value?.length === 1) {
            return `${value[0]?.label}`;
        }
        if (value?.length === 2) {
            return `${value[0]?.label} e ${value[1]?.label}`;
        }
        if (value?.length >= 3) {
            return `${value[0]?.label}, ${value[1]?.label} e ${value[2]?.label}`;
        }
        return '';
    };

    const renderTextFilters = () => {
        let aux = ""
        if(filters.dormitorios_min && filters.dormitorios_min != undefined){
            if(filters.dormitorios_min == "1")
                aux = " com 1 dormitório"
            else 
                aux = ` com ${filters.dormitorios_min} dormitórios`
        } else {
            if(filters.suites_min && filters.suites_min != undefined){
                if(filters.suites_min == "1")
                    aux = " com 1 suíte"
                else 
                    aux = ` com ${filters.suites_min} suítes`
            } else {
                if(filters.banheiros_min && filters.banheiros_min != undefined){
                    if(filters.banheiros_min == "1")
                        aux = " com 1 banheiro"
                    else 
                        aux = ` com ${filters.banheiros_min} banheiros`
                } else {
                    if(filters.garagems_min && filters.garagems_min != undefined){
                        if(filters.garagems_min == "1")
                            aux = " com 1 vaga"
                        else 
                            aux = ` com ${filters.garagems_min} vagas`
                    }
                }
            } 
        }
        if(promocao == "1"){
            if(allProperties?.length == 0){
                return (
                    <>
                        <h1 className={styles.qtd} style={{color: cor_detalhes}}>{`Imóveis em Promoção`}</h1>
                        {renderSeoIntro()}
                    </>
                );
            }

            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>{isNovember ? `${qtd} Black November` : `${qtd} Imóveis em Promoção`}</h1>
                    {renderSeoIntro()}
                </>
            );
        }
        if(openFavoritos){
            return (
                <h1 className={styles.qtd} style={{color: cor_detalhes}}>{`${
                    favorito?.length
                } ${favorito?.length > 1 ? 'Imóveis Favoritos' : 'imóvel Favorito'}`}</h1>
            );
        }
        if (companyActual) {
            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>{`${companyActual?.label} ${cityActual?.label ? `em ${cityActual?.label}` : ''}`}{aux}</h1>
                    {renderSeoIntro()}
                    <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                        <span data-nosnippet>{`${qtd || 0} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}</span>
                    </h2>
                </>
            );
        }
        if (typeValidation && !loading) {
            return (
                <>
                <h1 className={styles.qtd} style={{color: cor_detalhes}}>
                    {`${
                        site?.id != 2034
                        ?   typeActual?.length > 0
                            ?   qtd > 1
                                ?   concatLabels(typeActual)
                                    .replaceAll("Casas", "Casa")
                                    .replaceAll("Terrenos", "Terreno")
                                    .replaceAll("Apartamentos", "Apartamento")
                                    .replaceAll("Sobrados", "Sobrado")
                                    .replaceAll("Coberturas", "Cobertura")
                                    .replaceAll("Casa", "Casas")
                                    .replaceAll("Terreno", "Terrenos")
                                    .replaceAll("Apartamento", "Apartamentos")
                                    .replaceAll("Sobrado", "Sobrados")
                                    .replaceAll("Cobertura", "Coberturas")
                                :   concatLabels(typeActual)
                            : qtd > 1
                                ?   'Imóveis'
                                :   'Imóvel'
                        :   typeActual?.length > 0
                            ?   concatLabels(typeActual)
                            :   qtd > 1
                                ? 'Imóveis'
                                : 'Imóvel'
                    } ${categoryActual?.value ? categoryActual?.label : ''} ${typeValidation} ${
                        districtActual?.length > 0 ? concatLabels(districtActual) : ''
                    } ${cityActual?.label ? `em ${cityActual?.label}` : ''}`}{aux}
                </h1>
                {renderSeoIntro()}
                <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                    <span data-nosnippet>{`${site?.id != 1990 ? (qtd || 0) : ''} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}</span>
                </h2>
              </>
            );
        }
        if (!typeValidation && !loading) {
            return (
                <>
                    <h1 className={styles.qtd} style={{color: cor_detalhes}}>Empreendimentos{aux}</h1>
                    <h2 className={styles.qtd1} style={{color: cor_detalhes}}>
                        <span data-nosnippet>{`${qtd || ""} ${qtd > 1 ? 'Encontrados' : 'Encontrado'}`}</span>
                    </h2>
                </>
            );
        }
        return null;
    };

    const capitalizeFirstLetter = (text: string) => {
        if (!text) return text;
        return text.charAt(0).toUpperCase() + text.slice(1);
      };

    const renderOnlyTextFilters = () => {
        let aux = ""
        if(dormitorios && dormitorios != undefined){
            if(dormitorios == "1")
                aux = " com 1 dormitório"
            else 
                aux = ` com ${dormitorios} dormitórios`
        } else {
            if(suites && suites != undefined){
                if(suites == "1")
                    aux = " com 1 suíte"
                else 
                    aux = ` com ${suites} suítes`
            } else {
                if(banheiros && banheiros != undefined){
                    if(banheiros == "1")
                        aux = " com 1 banheiro"
                    else 
                        aux = ` com ${banheiros} banheiros`
                } else {
                    if(vagas && vagas != undefined){
                        if(vagas == "1")
                            aux = " com 1 vaga"
                        else 
                            aux = ` com ${vagas} vagas`
                    }
                }
            } 
        }
        const resposta = currentAsPath.split("/")
        if(resposta[7]){
            return `Imóvel cod: ${resposta[7]}`
        }
        if(resposta[5] && resposta[5] != "-"){
            return `${decodeURIComponent(resposta[5].replaceAll("-"," "))} ${resposta[3] && resposta[3] != "-" ? ` em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}` : ""}${aux}`
        }

        let resposta_tipo = []
        if(resposta[6])
            resposta_tipo = resposta[6].split("?")
        if(resposta_tipo[0] != "-" && resposta_tipo[0]){
            if(resposta[3] && resposta[3] != "-"){
                if(resposta[2] == "venda"){
                    return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                } else {
                    if(resposta[2] == "aluguel"){
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    if(resposta[2] == "temporada"){
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : allCities[0]?.label}${aux}`
                }
            }
            return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casas", "Casa").replaceAll("Casa", "Casas").replaceAll("Terrenos", "Terreno").replaceAll("Terreno", "Terrenos").replaceAll("Apartamentos", "Apartamento").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrados", "Sobrado").replaceAll("Sobrado", "Sobrados").replaceAll("Coberturas", "Cobertura").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para ${resposta[2]}${aux}`
        }
        if(resposta[3] && resposta[3] != "-"){
            if(resposta[2] == "venda"){
                return `Imóveis à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
            } else {
                if(resposta[2] == "aluguel"){
                    return `Imóveis para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                }
                if(resposta[2] == "temporada"){
                    return `Imóveis para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                }
                return `Imóveis em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : allCities[0]?.label}${aux}`
            }
        }
        return `Imóveis para ${resposta[2] ? resposta[2] : 'venda'}${aux}`
    };

    const registerSearch = async (searchParams = {}) => {
        if (typeof window === 'undefined') return;
        if (!site?.fb_token_pixel || !site?.fb_id_pixel) return;
        if (typeof navigator !== 'undefined' && !navigator.onLine) return;

        // Avoid repeated retries for the same search in a short interval.
        const requestKey = `${getSearchSignature(currentAsPath || '')}|${JSON.stringify(searchParams || {})}`;
        const now = Date.now();
        const lastRequest = searchEventRef.current;
        if (lastRequest?.key === requestKey && now - lastRequest.at < 15000) {
            return;
        }
        searchEventRef.current = { key: requestKey, at: now };

        let clientIpAddress = '';
        try {
            const ipResponse = await axios.get<{ ip: string }>('https://api64.ipify.org?format=json', {
                timeout: 1500,
            });
            clientIpAddress = ipResponse?.data?.ip || '';
        } catch {
            clientIpAddress = '';
        }

        const accessToken = site.fb_token_pixel;
        const pixelId = site.fb_id_pixel;
        const eventTime = Math.floor(Date.now() / 1000);
        const getCookie = (name: string) =>
            document.cookie
                .split('; ')
                .find((row) => row.startsWith(`${name}=`))
                ?.split('=')[1] || '';
        const fbc = getCookie('_fbc');
        const fbp = getCookie('_fbp');

        const userData: {
            client_ip_address?: string;
            fbc?: string;
            fbp?: string;
        } = {};
        if (clientIpAddress) {
            userData.client_ip_address = clientIpAddress;
        }
        if (fbc) {
            userData.fbc = fbc;
        }
        if (fbp) {
            userData.fbp = fbp;
        }

        const eventData = [
            {
                event_name: 'Search',
                event_time: eventTime,
                action_source: 'website',
                event_source_url: window.location.href,
                user_data: userData,
                custom_data: {
                    ...searchParams,
                },
            },
        ];

        try {
            await axios.post(
                `https://graph.facebook.com/v12.0/${pixelId}/events`,
                { data: eventData },
                {
                    params: { access_token: accessToken },
                    timeout: 2500,
                }
            );
        } catch (err) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('Falha ao registrar evento Search no Facebook Pixel:', err);
            }
        }
    };
    function debounce<F extends (..._args: any[]) => void>(fn: F, delay: number) {
        let timer: ReturnType<typeof setTimeout> | null = null;
        return (...args: Parameters<F>) => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    }

     const renderRodape = () => {
        switch (site?.rodape) {
            case 1:
                return (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                        viewport={{ once: true, amount: 0.22 }}
                    >
                        <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                    </motion.div>
                );
            case 2:
                return (
                    <AboutPieces allRodape={allDataHome?.rodape} site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1}/>
                );
            case 3:
                return (
                    <AboutPieces2 site={site} allRodape={allDataHome?.rodape}/>
                );
            default:
            return (
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    viewport={{ once: true, amount: 0.22 }}
                >
                    <AboutPieces1 site={site} allCities={allCities} allCitiesTipes={allDataHome?.tipos} codsite={codsite2} origin={origin} isMobile={isMobile1} allRodape={allDataHome?.rodape} favorito={favorito}/>
                </motion.div>
            );
        }
    }

    const debouncedGetInitial = useCallback(
        debounce(() => {
            setNaoEncontrou(false);
            const pathNow = getSearchSignature(currentAsPath || '');
            const hasContextCache = !!getFreshContextSearch(pathNow);
            const hasStorageCache =
                !hasContextCache &&
                typeof window !== 'undefined' &&
                !!getCachedSearch(currentAsPath || '')?.imoveis?.length;

            if (!hasContextCache && !hasStorageCache) {
                setLoading(true);
            }
            GetInitial();
            void registerSearch({
                content_category: renderOnlyTextFilters() || 'Busca de imóveis',
                currency: 'BRL',
                search_string: router.query?.city || "-",
                property_type: router.query?.type || "-",
                city: router.query?.city || "-",
                neighborhood: router.query?.district || "-"
            });
        }, 400),[autorizaBusca, filtersInitialized, currentAsPath, getOnlyQuery1, ultimaConsulta]
    );

    useEffect(() => {
        if (!router.isReady) return;

        const currentComparable = getSearchSignature(currentAsPath || '');
        const ultimaComparable = getSearchSignature(ultimaConsulta || '');
        if ((currentComparable !== ultimaComparable) && ultimaConsulta && filtersInitialized) {
            GetInitialFilters();
        }
    }, [router.isReady, currentAsPath]);

    useEffect(() => {
        if(router.isReady && filtersInitialized && autorizaBusca){
            setAutorizaBusca(false)
            debouncedGetInitial();
        }
    }, [autorizaBusca, filtersInitialized, router.isReady, debouncedGetInitial]);

    useEffect(() => {
        const requestId = latestCompanyRequestRef.current + 1;
        latestCompanyRequestRef.current = requestId;
        const companySearch = String(companyInputActual || '').trim();

        if (!companySearch) return;

        const timeOutId = setTimeout(async () => {
            await GetAllCompany(companySearch, requestId);
        }, 600);

        return () => clearTimeout(timeOutId);
    }, [companyInputActual, codsite1, condosStorageKey, origin]);

    return (
        <div className={styles.container} style={{background: site?.cor5}}>
            <Head>
                <title>{imoveisSeo?.title || (renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo)}</title>
                {/* Busca com 0 imóveis: sai do índice (evita soft 404 do Google) mas
                    segue funcionando p/ o usuário. Sobrescreve o robots global do _app
                    via key compartilhada; a página renderiza depois, então vence. */}
                {naoEncontrou ? (
                    <meta name="robots" content="noindex, follow" key="robots" />
                ) : null}
                {site?.url_icon && (
                    <link rel="icon" type="image/x-icon" href={site.url_icon} />
                )}
                {allProperties?.length > 0 && init_props?.prodOrigin ?
                    <RealEstateSchemaMarkup url={`https://${init_props?.prodOrigin}${currentAsPath}`} imoveis={allProperties} tipo={'card'}/>
                : null}
            </Head>
            <PopUpComponent site={site}/>
            <WhatsAppComponent site={site} />
            { favorito?.length > 0 ?
                <FavoritosComponent site={site} favorito={favorito} setAuxiliar={setFiltersInitialized} setAutorizaBusca={setAutorizaBusca} compartilhar={openFavoritos} setOpenFavoritos={setOpenFavoritos} zeraFiltros={zeraFiltros}/>
            : null }
            <WelcomePiecesCompany
                site={site}
                routes={initialFlow}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                bannerListagem={urlBannerListagem}
                props={allDataHome}
            />
            <ListPiecesProperties
                allProperties={allProperties}
                setAllProperties={setAllProperties}
                site={site}
                disableEntryMotion={disableEntryMotion}
                page={page}
                area={area}
                first={first}
                setAutorizaBusca={setAutorizaBuscaFromUser}
                allViewProperties={allViewProperties}
                setArea={setArea}
                setPage={setPage}
                searchList={GetInitial}
                qtd={qtd}
                filtersInitialized={filtersInitialized}
                typeValidation={typeValidation}
                typeActual={typeActual}
                setTypeActual={setTypeActual}
                districtActual={districtActual}
                setDistrictActual={setDistrictActual}
                companyActual={companyActual}
                setCompanyActual={setCompanyActual}
                cityActual={cityActual}
                setCityActual={setCityActual}
                codeActual={codeActual}
                setCodeActual={setCodeActual}
                orderActual={orderActual}
                setOrderActual={setOrderActual}
                price={price}
                setPrice={setPrice}
                filterPrice={filterPrice}
                setFilterPrice={setFilterPrice}
                listCity={listCity}
                listType={listType}
                listCompany={allCompany}
                categoryActual={categoryActual}
                setCategoryActual={setCategoryActual}
                setEstadoActual={setEstadoActual}
                estadoActual={estadoActual}
                listEstados={listEstados}
                allCities={allCities}
                setListCity={setListCity}
                listCategory={listCategory}
                listDatas={listDatas}
                dataEntregaActual={dataEntregaActual}
                setDataEntregaActual={setDataEntregaActual}
                listCaract={listCaracteristicas}
                caractActual={caractActual}
                setCaractActual={setCaractActual}
                type={type}
                setType={setType}
                listDistrict={listDistrict}
                setListDistrict={setListDistrict}
                filters={filters}
                setFilters={setFilters}
                applyFilter={applyFilter}
                activeLargeFilter={activeLargeFilter}
                setActiveLargeFilter={setActiveLargeFilter}
                companyInputActual={companyInputActual}
                setCompanyInputActual={setCompanyInputActual}
                loading={loading}
                setLoading={setLoading}
                renderTextFilters={renderTextFilters}
                agenciador={idAgenciador}
                setAgenciador={setAgenciador}
                allPropertiesMapa={allPropertiesMapa}
                favorito={favorito || []}
                openFavoritos={openFavoritos}
                setOpenFavoritos={setOpenFavoritos}
                naoEncontrou={naoEncontrou}
                zeraFiltros={zeraFiltros}
                setFavorito={setFavorito}
                allUrl={allUrl}
                origin={origin}
                codsite={codsite1}
                codsite2={codsite}
                valores={valores}
            />
            { renderRodape() }
        </div>
    );
};

export default Properties;
